import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { App } from './app';
import { store } from './store';
const container = document.querySelector('#root');
const root = createRoot(container);
root.render(_jsx(Provider, { store: store, children: _jsx(App, {}) }));
